module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "boy4",
      "transform": "translate(1766.000000, 238.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.23437433,119.833515 C6.22417185,121.362001 5.2213115,122.21414 4.251553,124.017746 C3.12008462,126.122108 3.25386818,129.892675 2,133.081165 C2.36262642,133.813561 4.52456876,132.43195 4.96435181,131.15086 C5.40413486,129.869771 5.73757214,128.828764 5.89023135,128.504666 C6.04289055,128.180568 6.42322505,128.202824 6.53959242,128.508839 C6.6559598,128.814854 6.95446741,139.941834 7.19342917,140.487097 C7.43239093,141.03236 8.7545617,141.051741 8.98243159,140.487097 C9.21030148,139.922453 9.17936099,131.118682 9.2909608,130.883051 C9.40256062,130.647419 9.69318716,130.76083 9.81587885,130.883051 C9.93857053,131.005271 9.72694927,140.409758 9.92436515,140.759728 C10.121781,141.109698 11.487249,141.049051 11.6349461,140.759728 C11.7826431,140.470405 11.8333349,131.09587 11.9818104,130.883051 C12.1302858,130.670231 12.4311285,130.694064 12.5542094,130.883051 C12.6772903,131.072038 12.3414206,140.099292 12.5542094,140.487097 C12.7669982,140.874901 14.0909204,140.881021 14.2127364,140.487097 C14.3345524,140.093172 14.6048438,131.014916 14.7330815,130.883051 C14.8613191,130.751186 15.0338269,130.76352 15.1560321,130.883051 C15.2782373,131.002582 15.4075452,137.783038 15.6187773,138.151554 C15.8300094,138.52007 16.8319752,138.607145 16.9796723,138.151554 C17.1273693,137.695963 16.4211207,121.167126 16.4407859,120.249845 C16.5063217,117.192945 14.7733113,114 11.2963315,114 C7.81935166,114 6.25628331,116.551217 6.23437433,119.833515 Z",
      "id": "boy4_right_hand",
      "fill": "#EFAC60",
      "transform": "translate(9.500000, 127.500000) rotate(6.000000) translate(-9.500000, -127.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.0000626,82.9999997 L15.0000626,82.9999997 L15.0000626,82.9999997 C19.4140132,82.9999997 22.9922271,86.5782137 22.9922271,90.9921643 C22.9922271,91.1030894 22.9899178,91.2140024 22.9853006,91.3248314 L21.8653357,118.208121 L21.8653357,118.208121 C21.7537634,120.886268 19.5501392,123 16.869669,123 L13.1304561,123 L13.1304561,123 C10.4499859,123 8.24636172,120.886268 8.1347894,118.208121 L7.01482449,91.3248314 L7.01482449,91.3248314 C6.83109751,86.9147062 10.2572702,83.1906532 14.6673954,83.0069262 C14.7782244,83.002309 14.8891375,82.9999997 15.0000626,82.9999997 Z",
      "id": "boy4_right_arm_bottom",
      "fill": "#DD8C32",
      "transform": "translate(14.999997, 103.000000) rotate(6.000000) translate(-14.999997, -103.000000) "
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy4_right_arm_top",
      "fill": "#DD8C32",
      "transform": "translate(17.500000, 76.500000) rotate(6.000000) translate(-17.500000, -76.500000) ",
      "x": "10",
      "y": "54",
      "width": "15",
      "height": "45",
      "rx": "7.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.6455811,209 L31,209 L31,225 L2.84217094e-14,225 C0.259246233,220.418463 2.40244073,217.751796 6.42958348,217 C10.4567262,216.248204 13.8620588,213.581537 16.6455811,209 Z",
      "id": "boy4_right_shoe_4",
      "fill": "#955208"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31,223 L31,225 L2.84217094e-14,225 C0.0956575752,224.076951 0.194871797,223.410284 0.297642666,223 C0.612255249,223 10.8463744,223 31,223 Z",
      "id": "boy4_right_shoe_3",
      "fill": "#AE6C23"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy4_right_shoe_2",
      "fill": "#AE6C23",
      "points": "16 216.575943 14.9730269 218 11 215.088172 12.2613354 214"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy4_right_shoe_1",
      "fill": "#AE6C23",
      "points": "19 213.4 18.0199074 215 14 212.460322 15.0209099 211"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23,155 L23,155 L23,155 C27.9705627,155 32,159.029437 32,164 L32,209 L14,209 L14,164 L14,164 C14,159.029437 18.0294373,155 23,155 Z",
      "id": "boy4_right_leg_bottom",
      "fill": "#AE6C23"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy4_right_leg_top",
      "fill": "#AE6C23",
      "x": "14",
      "y": "109",
      "width": "18",
      "height": "62",
      "rx": "9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.6455811,209 L54,209 L54,225 L23,225 C23.2592462,220.418463 25.4024407,217.751796 29.4295835,217 C33.4567262,216.248204 36.8620588,213.581537 39.6455811,209 Z",
      "id": "boy4_left_shoe_4",
      "fill": "#955208"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54,223 L54,225 L23,225 C23.0956576,224.076951 23.1948718,223.410284 23.2976427,223 C23.6122552,223 33.8463744,223 54,223 Z",
      "id": "boy4_left_shoe_3",
      "fill": "#AE6C23"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy4_left_shoe_2",
      "fill": "#AE6C23",
      "points": "40 216.575943 38.9730269 218 35 215.088172 36.2613354 214"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy4_left_shoe_1",
      "fill": "#AE6C23",
      "points": "43 213.4 42.0199074 215 38 212.460322 39.0209099 211"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47,155 L47,155 L47,155 C51.9705627,155 56,159.029437 56,164 L56,209 L38,209 L38,164 L38,164 C38,159.029437 42.0294373,155 47,155 Z",
      "id": "boy4_left_leg_bottom",
      "fill": "#AE6C23"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47,109 L47,109 L47,109 C51.9705627,109 56,113.029437 56,118 L56,162 L56,162 C56,166.970563 51.9705627,171 47,171 L47,171 L47,171 C42.0294373,171 38,166.970563 38,162 L38,118 L38,118 C38,113.029437 42.0294373,109 47,109 Z",
      "id": "boy4_left_leg_top",
      "fill": "#AE6C23"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14,112 L57,112 L57,112 L57,112 C57,123.59798 47.5979797,133 36,133 L35,133 L35,133 C23.4020203,133 14,123.59798 14,112 L14,112 Z",
      "id": "boy4_hip",
      "fill": "#AE6C23"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24,112 C24.6959544,112 26.3626211,112 29,112 C29,121.503505 29,126.836838 29,128 C24.3058905,124.549028 24,120.920725 24,112 Z",
      "id": "boy4_zipper",
      "fill": "#C6853C"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.9109748,56.9418184 C20.8686252,46.5122924 47.9139403,48.9390232 52.9862418,56.9418184 C60.0392218,68.0696176 57.8101695,108.724652 57.1000888,109.819379 C50.7852938,119.55486 17.1742207,116.049716 12.51769,111.123953 C10.5237672,109.014745 14.7848852,62.5446646 16.9109748,56.9418184 Z",
      "id": "boy4_torso",
      "fill": "#DD8C32"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.2343743,120.833515 C47.2241719,122.362001 46.2213115,123.21414 45.251553,125.017746 C44.1200846,127.122108 44.2538682,130.892675 43,134.081165 C43.3626264,134.813561 45.5245688,133.43195 45.9643518,132.15086 C46.4041349,130.869771 46.7375721,129.828764 46.8902313,129.504666 C47.0428905,129.180568 47.4232251,129.202824 47.5395924,129.508839 C47.6559598,129.814854 47.9544674,140.941834 48.1934292,141.487097 C48.4323909,142.03236 49.7545617,142.051741 49.9824316,141.487097 C50.2103015,140.922453 50.179361,132.118682 50.2909608,131.883051 C50.4025606,131.647419 50.6931872,131.76083 50.8158788,131.883051 C50.9385705,132.005271 50.7269493,141.409758 50.9243652,141.759728 C51.121781,142.109698 52.487249,142.049051 52.6349461,141.759728 C52.7826431,141.470405 52.8333349,132.09587 52.9818104,131.883051 C53.1302858,131.670231 53.4311285,131.694064 53.5542094,131.883051 C53.6772903,132.072038 53.3414206,141.099292 53.5542094,141.487097 C53.7669982,141.874901 55.0909204,141.881021 55.2127364,141.487097 C55.3345524,141.093172 55.6048438,132.014916 55.7330815,131.883051 C55.8613191,131.751186 56.0338269,131.76352 56.1560321,131.883051 C56.2782373,132.002582 56.4075452,138.783038 56.6187773,139.151554 C56.8300094,139.52007 57.8319752,139.607145 57.9796723,139.151554 C58.1273693,138.695963 57.4211207,122.167126 57.4407859,121.249845 C57.5063217,118.192945 55.7733113,115 52.2963315,115 C48.8193517,115 47.2562833,117.551217 47.2343743,120.833515 Z",
      "id": "boy4_left_hand",
      "fill": "#EFAC60"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.0000625,84 L53.0000625,84 L53.0000625,84 C57.4140131,84 60.9922271,87.578214 60.9922271,91.9921646 C60.9922271,92.1030897 60.9899178,92.2140027 60.9853006,92.3248317 L59.8653357,119.208121 L59.8653357,119.208121 C59.7537634,121.886268 57.5501391,124 54.869669,124 L51.1304561,124 L51.1304561,124 C48.4499859,124 46.2463617,121.886268 46.1347894,119.208121 L45.0148245,92.3248317 L45.0148245,92.3248317 C44.8310975,87.9147065 48.2572702,84.1906535 52.6673954,84.0069265 C52.7782244,84.0023093 52.8891374,84 53.0000625,84 Z",
      "id": "boy4_left_arm_bottom",
      "fill": "#DD8C32"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy4_left_arm_top",
      "fill": "#DD8C32",
      "x": "45",
      "y": "55",
      "width": "15",
      "height": "45",
      "rx": "7.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.6062561,47.6271687 C28.0326024,50.3639486 28.2185326,51.9946575 27,53.5000112 C27.208057,53.8850171 28.6080469,56.3850134 31.1999699,61 C35.3357769,56.4126582 37.6024536,53.9126619 38,53.5000112 C36.8964974,51.9578822 36.822926,50.6850552 37.4780771,47.6271687 C36.6639526,45.4208313 28.743074,45.494704 27.6062561,47.6271687 Z",
      "id": "boy4_neck",
      "fill": "#EFAC60"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "boy4_head"
    }
  }, [_c('path', {
    attrs: {
      "d": "M52.6219302,27.7925591 C53.7653972,27.1270401 55.4069602,26.2815912 57.2681481,27.7925591 C58.8601278,29.0849757 57.6634428,34.1552654 55.5159248,36.9631758 C53.3887598,39.7444742 49.9285261,40.3219255 48.5703377,39.2558299 C45.7048873,45.6476669 38.4020728,49.0418698 33.5215656,48.9996101 C20.4554214,48.8864723 15,35.798348 15,24.9267414 C15,7.77874329 21.9257165,2.00042705 33.5215656,2.00042705 C43.9295473,1.94438784 55.4820108,7.38760116 52.6219302,27.7925591 Z",
      "id": "boy4_face",
      "fill": "#EFAC60",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "boy4_mouth_bottom"
    }
  }, [_c('path', {
    attrs: {
      "d": "M26.2255207,45 C27.0239603,45 33.9558673,45 34.8478779,45 C35.7398884,45 32.5397111,43 29.6646868,43 C26.7896625,43 25.4270812,45 26.2255207,45 Z",
      "fill": "#C6853C",
      "transform": "translate(30.500000, 44.000000) scale(1, -1) translate(-30.500000, -44.000000) "
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.2756365,43 C26.251507,43 34.7238378,43 35.814073,43 C36.9043081,43 32.9929802,41 29.4790616,41 C25.965143,41 24.2997659,43 25.2756365,43 Z",
      "id": "boy4_mouth_top",
      "fill": "#C6853C"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.0999397,27.8560167 C28.2908361,26.7499578 30.5057953,26.6799018 30.6148935,27.8560167 C30.7239917,29.0321317 31.4232759,35.2115361 30.6161288,36.3083792 C29.8089817,37.4052223 27.4362731,37.0377283 27.0690792,36.3083792 C26.7018853,35.5790301 27.9090434,28.9620757 28.0999397,27.8560167 Z",
      "id": "boy4_nose",
      "fill": "#C6853C"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy4_glasses_3",
      "stroke": "#955208",
      "stroke-width": "2",
      "fill": "#FBD79E",
      "x": "34",
      "y": "25",
      "width": "12",
      "height": "9",
      "rx": "4.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.2692308,30 L33,30",
      "id": "boy4_glasses_2",
      "stroke": "#955208",
      "stroke-width": "3",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy4_glasses_1",
      "stroke": "#955208",
      "stroke-width": "2",
      "fill": "#FBD79E",
      "x": "15",
      "y": "25",
      "width": "12",
      "height": "9",
      "rx": "4.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24.9806242,23.0486983 C24.6804136,21.6905474 15.2028012,21.6691721 15.0126056,22.882419 C14.8224101,24.0956658 16.8073431,23.5171795 19.419735,23.749311 C22.032127,23.9814424 25.2808349,24.4068492 24.9806242,23.0486983 Z",
      "id": "boy4_right_brow",
      "fill": "#AE6C23"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.0193758,23.0486983 C34.3195864,21.6905474 43.7971988,21.6691721 43.9873944,22.882419 C44.1775899,24.0956658 42.1926569,23.5171795 39.580265,23.749311 C36.967873,23.9814424 33.7191651,24.4068492 34.0193758,23.0486983 Z",
      "id": "boy4_left_brow",
      "fill": "#AE6C23"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.2252698,11.320961 C23.9435493,16.4863496 28.13402,22.8493464 29.6339864,24.3599176 C29.9708067,23.3714096 29.9432879,19.9581886 29.6339864,18.7785783 C30.5487021,19.7929582 33.0318642,23.3465376 33.7965579,24.8883551 C34.201351,22.988455 34.4657304,20.250904 34.201351,18.7785783 C35.5504076,20.250904 37.7861539,23.1530605 38.6657419,24.8883551 C39.3622092,23.1530605 40.0946919,21.1837936 40.0946919,20.250904 C41.1959523,21.3422748 44.5286472,25.7227563 45.6413209,27.0905944 C45.9733223,25.4282912 45.9733223,24.3599176 45.9733223,23.1530605 C46.777075,24.094949 48.3480577,27.0988434 49.0625327,28.8568853 C49.7123321,27.7437671 50.1677243,26.2251968 50.1677243,23.9697138 C51.0594865,25.674262 51.2798908,28.0722282 51.6045369,30 C52.3857165,28.9261271 52.8058542,27.499546 53.1510443,26.6341484 C53.6580502,27.3433145 54.71036,28.7471483 55.6165791,29.7540291 C56.3465255,25.5945215 56.1738037,20.250904 54.71036,17.3974918 C56.1738037,18.2261437 57.784099,18.7785783 59,18.7785783 C54.6974249,13.9626483 55.8506794,10.5890477 50.1171252,6.87998671 C51.9455421,7.0667146 54.4871658,7.66264406 56.1738037,7.47591617 C53.941101,5.49490066 47.827863,2.92120531 45.6413209,2.239536 C43.4547789,1.55786668 39.0512591,-0.287914831 33.7965579,0.0382965556 C28.5418567,0.364507942 26.2602034,1.91957387 24.8048759,3.67686586 C22.1191905,2.95620116 19.3850617,1.72459695 17.9814747,1.01293119 C18.1491239,1.97981674 19.0119724,3.67686586 19.9592795,4.88772253 C15.8555501,6.14182408 15.2387225,11.8463988 10,15.72269 C11.0053883,16.0259041 12.6790911,15.840926 14.0139445,15.4009781 C13.1726546,16.6965747 10.867921,20.250904 11.275504,22.7443588 C12.035886,21.6792349 13.3164626,20.250904 14.0139445,19.9581886 C13.7253138,21.4857578 13.3753047,23.7237429 14.4595719,25.7992472 C15.6366676,21.7372281 18.7367841,14.3143567 23.2252698,11.320961 Z",
      "id": "boy4_hair",
      "fill": "#AE6C23"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71ffe5a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_6/svg/backgroundCharacters/boyFour.vue
// module id = 986
// module chunks = 1